import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const AnonymousModalLabel = styled.span<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['light']};
  font-size: ${20 * Screen.widthRatio}px;
  height: ${61 * Screen.widthRatio}px;
  line-height: ${27 * Screen.widthRatio}px;
  text-align: center;
  width: ${150 * Screen.widthRatio}px;
  margin-top: ${20 * Screen.widthRatio}px;
`;

export default AnonymousModalLabel;
